import PropTypes from "prop-types";
import { TextField, InputAdornment } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useId } from "react";

TextFieldBig.propTypes = {
  fullWidth: PropTypes.bool,
  autoFocus: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onEnter: PropTypes.func,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  endAdornment: PropTypes.node,
};

function TextFieldBig(props) {
  const classes = useStyles();
  const uniqueId = useId();

  const onEnter = (e) => {
    if (e.key === "Enter") {
      props.onEnter(e);
    }
  };

  const endIcon = props.endAdornment ? (
    <InputAdornment position="end">{props.endAdornment}</InputAdornment>
  ) : (
    ""
  );

  return (
    <div className="text-field">
      {props.label && (
        <label htmlFor={uniqueId} className="select-label text-field__label">
          {props.label}
        </label>
      )}
      <TextField
        type="text"
        id={uniqueId}
        classes={classes}
        autoFocus={props.autoFocus}
        fullWidth={props.fullWidth}
        placeholder={props.placeholder}
        variant="outlined"
        margin="none"
        value={props.value}
        onChange={props.onChange}
        onKeyUp={onEnter}
        onBlur={props.onBlur}
        slotProps={{
          input: {
            endAdornment: endIcon,
            autoComplete: props.autoComplete,
          },
        }}
        helperText={props.helperText}
        error={props.error}
        sx={props.sx}
        autoComplete={props.autoComplete}
      />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "450px",
    backgroundColor: "#fff",
    "& .MuiOutlinedInput-input": {
      padding: "6px 10px 6px 13px",
    },
  },
}));

export default TextFieldBig;
